import { useT } from "../lib/prefs";

const Row = ({ hidden, words }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {words.map((w, i) => (
      <span key={w} className="flex items-center font-display uppercase text-lg sm:text-2xl lg:text-3xl font-black px-3 sm:px-6 whitespace-nowrap">
        <span className={i === 1 || i === 2 ? "text-violet-300" : "text-white"}>{w}</span>
        <span className="ml-6 sm:ml-12 text-violet-400 text-base sm:text-xl">✦</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => {
  const t = useT();
  return (
  <section className="relative py-3 sm:py-4 border-y border-violet-500/20 bg-[#0F0722] overflow-hidden" data-testid="marquee-section">
    <div className="flex w-max animate-marquee">
      <Row words={t.marquee} />
      <Row hidden words={t.marquee} />
    </div>
  </section>
  );
};
